/**
 * Linear issue identifier shape: an uppercase team key (`OL`, `INF`, `CLA`, `DCG`)
 * followed by a dash and a number. Anything else is not a task and must never
 * reach the task-detail page.
 *
 * A tiny pure module (no atoms, no design imports) so the eager
 * `task/$issueIdentifier.tsx` route file can gate its `beforeLoad` without
 * pulling the orca-admin chunk into the always-loaded graph.
 *
 * @since 1.0.0
 */

/**
 * Matches an uppercase team key followed by a dash and a number, e.g. `INF-829`.
 *
 * @since 1.0.0
 */
export const LINEAR_ISSUE_IDENTIFIER_PATTERN = /^[A-Z][A-Z0-9]*-\d+$/;

/**
 * Type guard: `true` only when `value` is a well-formed Linear issue identifier.
 *
 * @since 1.0.0
 */
export const isLinearIssueIdentifier = (value: string | undefined): value is string =>
  value !== undefined && LINEAR_ISSUE_IDENTIFIER_PATTERN.test(value);
